import { Injectable } from '@angular/core';

@Injectable()
export class DatatableQueryService {

    protected lastQueryParams = {};

    constructor() {

    }

    public getLastQueryParams() {
        return this.lastQueryParams;
    }

    public setLastQueryParams(params) {
        this.lastQueryParams = params;
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/datatables/services/datatable-query.service.ts